<ng-container *ngIf="viewModel$ | async as vm">

  <app-cp-compare-measure-card-group label="common-app.__NOISE" icon="sound-32" [measureCards]="vm.measureCards">
    <ng-container *ngFor="let measureCard of vm.measureCards">
      <app-cp-compare-measure-card [measureCard]="measureCard"></app-cp-compare-measure-card>
    </ng-container>
  </app-cp-compare-measure-card-group>

</ng-container>